export default "__VITE_ASSET__gzW6eW9s__"